import { CheckCircle, PlayCircle, HelpCircle, Newspaper, Search, Lightbulb, Shield, Users } from "lucide-react";

export const MAX_UNACKNOWLEDGED_ITEMS = 6;
export const ARCHIVE_THRESHOLD = 20;

// One visual language for every stream type (same as lead cards: teal section label, white/gray body)
const TYPES = {
  question: { label: "Agent Needs Input", Icon: HelpCircle },
  competitor: { label: "Competitive Alert", Icon: Shield },
  strategy: { label: "Sales Strategy", Icon: Lightbulb },
  research: { label: "Account Research", Icon: Search },
  news: { label: "News", Icon: Newspaper },
  prospect: { label: "New Leads", Icon: Users },
};
const STATUS = {
  viewed: { suffix: " (Viewed)", StatusIcon: CheckCircle, statusColor: "text-gray-500" },
  executed: { suffix: " (Executed)", StatusIcon: PlayCircle, statusColor: "text-ism-teal" },
};

export const getTypeMeta = (priority, status) => {
  const type = TYPES[priority] || { label: "Update", Icon: Lightbulb };
  const state = STATUS[status] || { suffix: "", StatusIcon: null, statusColor: null };
  return { ...type, label: type.label + state.suffix, StatusIcon: state.StatusIcon, statusColor: state.statusColor };
};

export const ageLabel = (isoDate) => {
  if (!isoDate) return null;
  const days = Math.floor((Date.now() - new Date(isoDate).getTime()) / 86400000);
  if (Number.isNaN(days)) return null;
  if (days <= 0) return "today";
  if (days === 1) return "yesterday";
  return `${days} days ago`;
};

const KNOWN_PRIORITIES = ["prospect", "news", "research", "strategy", "competitor"];

// Backend stream_items row → card model.
export const fromPersisted = (item) => ({
  activityId: item.activityId,
  text: item.description || item.text,
  hasButton: item.type !== "question",
  priority: KNOWN_PRIORITIES.includes(item.type) ? item.type : "prospect",
  fullData: item.metadata || {},
  type: item.type,
  status: item.status || "viewed",
  isArchived: item.isArchived || false,
  viewedAt: item.reviewedAt,
  createdAt: item.createdAt,
});

const GENERATED_PRIORITY = { question: "question", prospect: "prospect", research: "research", news: "news", strategy: "strategy" };

// Fresh /agent/auto-activity payload → card model.
export const fromGenerated = (activityData) => {
  const type = activityData.type;
  return {
    activityId: activityData.activityId || `stream-${Date.now()}`,
    text: activityData.summary,
    hasButton: type !== "question",
    priority: GENERATED_PRIORITY[type] || "competitor",
    fullData: activityData,
    type,
    status: "new",
    isArchived: false,
    viewedAt: null,
    executedAt: null,
    createdAt: new Date().toISOString(),
    question: type === "question" ? {
      text: activityData.question || activityData.summary,
      type: activityData.questionType || "short",
      hint: activityData.hint,
      options: activityData.options || [],
      context: activityData.context,
    } : null,
    questionId: activityData.questionId,
  };
};

export const formatArchiveDate = (dateStr) => {
  const date = new Date(dateStr);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  if (dateStr === today.toISOString().slice(0, 10)) return "Today";
  if (dateStr === yesterday.toISOString().slice(0, 10)) return "Yesterday";
  return date.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", year: date.getFullYear() !== today.getFullYear() ? "numeric" : undefined });
};
